import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApplicationDataService } from '../../../services/application.service';
import { ApplicantBasic } from '../../models/applicantbasic';
import { Property } from '../../models/property';
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import { AddApplicantDialogComponent } from './add-applicant-dialog/add-applicant-dialog.component';
import { RemoveApplicantDialogComponent } from './remove-applicant-dialog/remove-applicant-dialog.component';
import { AddApplicantInfoDialogComponent } from './add-applicant-info-dialog/add-applicant-info-dialog.component';
import { EventEmitterService } from 'services/event-emitter.service';
import { SplashService } from 'services/splash.service';
import { ErrorService } from '../../../services/error.service';
import { NumberInput } from '@angular/cdk/coercion';
import { ApplicationInterface } from 'app/interface/application';
import { AnalyticsService } from 'services/analytics.service';
import { RentablesDataService } from 'services/rentables.service';
import { AdditionalApplicationStepsInterface } from 'app/interface/additionalApplicationStepsInterface';

@Component({
  selector: 'app-applicants',
  templateUrl: './applicants.component.html',
  styleUrls: ['./applicants.component.css']
})
export class ApplicantsComponent implements OnInit {
  RentalApplicationKey: number;
  RentalApplicantKey: number;
  applicants: ApplicantBasic[];
  errorMessage: string = null;
  PrimaryApplicant: number = null;
  displayRemoveMsg = false;
  displayAddMsg = false;
  displayEmailInputMsg = false;
  removedPerson: string;
  removedPersonRecord: ApplicantBasic;
  model: ApplicantBasic;
  modalErrorMsg: string = null;
  modalErrorMsgLink: string = null;
  modelProperty: Property;
  splashHTML: string;
  hasRentableItems: boolean = false;
  totalApplicationSteps: number = 8;
  currentApplicationStep: number = 7;
  verifastEnabled: boolean;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private applicationService: ApplicationDataService,
    private rentablesService: RentablesDataService,
    public dialog: MatDialog,
    private eventEmitterService: EventEmitterService,
    private splashService: SplashService,
    private errorService: ErrorService,
    private readonly analyticsService: AnalyticsService) {
    this.analyticsService.track(
      'HRA Application',
      'Applicants',
      'Start',
      'Start',
      '',
      this.additionalAnalyticsDetails());
    this.applicants = [];
    this.model = new ApplicantBasic();
    const RentalApplicationKey = localStorage.getItem('RentalApplicationKey');
    const RentalApplicantKey = localStorage.getItem('RentalApplicantKey');
    const rentableItems = localStorage.getItem('hasRentableItems');
    const ancillaryItems = localStorage.getItem('HasAncillaryItems');
    const verifastEnabled = localStorage.getItem('verifastEnabled');
    localStorage.removeItem('InviteHRA');
    const correctStatus = localStorage.getItem('CorrectStatus');
    const yardiKey = localStorage.getItem('YardiKey');

    if (correctStatus != "true")
    {
      localStorage.removeItem('RentalApplicationKey');
      this.analyticsService.track(
        'HRA Application',
        'Applicants',
        'Stop',
        'Application not in the correct status',
        '/application/dashboard',
        this.additionalAnalyticsDetails());
      this.router.navigate(['/application/dashboard']);
    }

    if(rentableItems === null || verifastEnabled === null || ancillaryItems === null){
      this.rentablesService.GetPropertyHasRentableItems(RentalApplicationKey, yardiKey).subscribe(res => this.setRentableItemsFlag(res));
    }

    this.eventEmitterService.splashChangeEmitted$.subscribe(res => this.updateSplashHTML(res));
    this.splashService.updateSplash("apply");
    this.applicationService.verifyBackgroundCheck(RentalApplicationKey, RentalApplicantKey).subscribe(res => this.verifyBackgroundCheck(res), err => this.backgroundCheckError(err));

    if (RentalApplicationKey !== undefined && RentalApplicationKey !== null &&
      RentalApplicantKey !== undefined && RentalApplicantKey !== null) {

      this.RentalApplicationKey = Number(RentalApplicationKey);
      this.RentalApplicantKey = Number(RentalApplicantKey);

      this.applicationService.getApplicantsForApplication(this.RentalApplicationKey)
      .subscribe(res => this.onGetApplicants(res), err => this.errorService.showError(err));
    } else {
      this.analyticsService.track(
        'HRA Application',
        'Applicants',
        'Stop',
        'Application or applicant not in the right state',
        '/application/landing',
        this.additionalAnalyticsDetails());
      this.router.navigate(['/application/landing']);
    }
   }

  private additionalAnalyticsDetails(): any {
    try {
      return {
        'Applicants': this.applicants
          ?.filter(x => x.ApplicantStatus != 'Add Another Applicant')
          ?.map(x =>
            {
              return {
                'ApplicantStatus': x.ApplicantStatus,
                'AdCopy': x.AdCopy,
                'AdGroup': x.AdGroup,
                'Campaign': x.Campaign,
                'CompletedByOther': x.CompletedByOther,
                'Device': x.Device,
                'Keyword': x.Keyword,
                'InterestedInSmartHome': x.InterestedInSmartHome,
                'IsPrimary': x.IsPrimary,
                'IsWaitListed': x.IsWaitListed
              }
            })
      };
    } catch (error) {
      console.error(error);
      return {};
    }
  }

  updateSplashHTML(res: string)
  {
    this.splashHTML = res;
  }

  verifyBackgroundCheck(hasBackgroundCheck: boolean) {
    if(!hasBackgroundCheck) {
      this.analyticsService.track(
        'HRA Application',
        'Applicants',
        'Stop',
        'Background check is not complete, sending to background check',
        '/application/background-check',
        this.additionalAnalyticsDetails());
      this.router.navigate(['/application/background-check']);
    }
  }

  backgroundCheckError(err: any){
    this.errorService.showError(err);
    this.analyticsService.track(
      'HRA Application',
      'Applicants',
      'Stop',
      'Error: Verify background check',
      '/application/background-check',
      this.additionalAnalyticsDetails());
    this.router.navigate(['/application/background-check']);
  }

  ngOnInit() {
    const rentableItems = localStorage.getItem('hasRentableItems');
    const verifastEnabled = localStorage.getItem('verifastEnabled');
    const hasAncillaryItems = localStorage.getItem('HasAncillaryItems');
    if ((rentableItems && rentableItems === 'true') || (hasAncillaryItems && hasAncillaryItems === 'true')) {
      this.hasRentableItems = true;
      this.totalApplicationSteps = 9;
    }

    if (verifastEnabled && verifastEnabled === 'true') {
      this.verifastEnabled = true;
      this.totalApplicationSteps++;
      this.currentApplicationStep++;
    }

    const property = JSON.parse( localStorage.getItem('SelectedProperty'));
    if (property != null) {
        this.modelProperty = property[0];
        if((property[0].min_rent != null && property[0].max_rent != null) && (property[0].min_rent == property[0].max_rent)){
          this.modelProperty.rent = property[0].min_rent.toLocaleString();
        }
        else if (property[0].min_rent != null && property[0].max_rent != null) {
          this.modelProperty.rent = property[0].min_rent.toLocaleString() + '-$'+ property[0].max_rent.toLocaleString()
        }
    }
  }

  onGetApplicants(applicants: ApplicantBasic[]) {
    this.applicants = applicants;
    let addApplicant = new ApplicantBasic();
    for(let app of this.applicants)
    {
      if(app.IsPrimary == true)
      {
        this.PrimaryApplicant = app.RentalApplicantKey;
      }
    }

    addApplicant.FirstName = 'Add Applicant';
    addApplicant.ApplicantStatus = 'Add Another Applicant';
    this.applicants.push(addApplicant);
  }

  applicantClick() {
    this.analyticsService.track(
      'HRA Application',
      'Applicants',
      'Stop',
      'Sending to applicant',
      '/application/applicant',
      this.additionalAnalyticsDetails());
    this.router.navigate(['/application/applicant']);
  }

  completeMyselfClick() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = "300px";

    let dialogRef = this.dialog.open(AddApplicantInfoDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.model.FirstName = result.FirstName;
      this.model.LastName = result.LastName;
      this.model.Email = result.Email;

      this.startCompleteMyself();
    });
  }

  setRentableItemsFlag = (res: AdditionalApplicationStepsInterface) => {
    localStorage.setItem('hasRentableItems', res.toString());
    localStorage.setItem('HasAncillaryItems', res.HasAncillaryItems.toString());
    localStorage.setItem('verifastEnabled', res.VerifastEnabled.toString());
    if (res.HasRentableItems || res.HasAncillaryItems) {
      this.hasRentableItems = true;
      this.totalApplicationSteps = 9;
    }
    if (res.VerifastEnabled) {
      this.verifastEnabled = true;
      this.currentApplicationStep++;
      this.totalApplicationSteps++;
    }
  }

  startCompleteMyself() {
    this.modalErrorMsg = null;
    this.model.RentalApplicationKey = this.RentalApplicationKey;
    this.applicationService.checkAdditionalApplicantRecord(this.model)
      .subscribe(res => this.continueCompleteMyself(res), res => this.modalErrorMsg = this.applicationService.handleError(res));
  }

  continueCompleteMyself(result: boolean){
    if(result == false)
    {
      //User applicant already exists in DB
      this.errorService.showError("This record already exists and was created by a different user. To add this person, you must invite them to the application.");
    }
    else if(result == true)
    {
      this.applicationService.assignOrCreateAdditionalApplicant(this.model)
      .subscribe(res => this.beginApplication(res), res => this.modalErrorMsg = this.applicationService.handleError(res));
    }
    else {
      this.errorService.showError("There was an issue verifying the chosen email.")
    }
  }

  beginApplication(assignedApplicantKey: number)
  {
    localStorage.setItem('AddAdditionalApplicantKey', assignedApplicantKey.toString());
    this.analyticsService.track(
      'HRA Application',
      'Applicants',
      'Stop',
      'Begin application, sending to basic',
      '/application/basic',
      this.additionalAnalyticsDetails());
    this.router.navigate(['/application/basic']);
  }

  addApplicantClick() {
    this.model = new ApplicantBasic();
    this.displayAddMsg = true;
    this.modalErrorMsgLink = null;
    this.modalErrorMsg = null;

    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = "300px";

    let dialogRef = this.dialog.open(AddApplicantDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if(result == "completeMyself"){
        this.completeMyselfClick();
      }
      else if(result == "sendInvite"){
        this.applicantClick();
      }
    });
  }

  removeApplicantClick(applicant: ApplicantBasic) {
    this.displayRemoveMsg = true;
    this.removedPersonRecord = applicant;

    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = "300px";
    dialogConfig.data = { removedPerson: applicant.FirstName + " " + applicant.LastName}

    let dialogRef = this.dialog.open(RemoveApplicantDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if(result == "confirmRemove"){
        this.onContinueRemoveApplicant();
      }
      else if(result == "cancelRemove"){
        this.onCloseRemoveWarning();
      }
    });
  }

  editApplicant(applicant: ApplicantBasic) {
    let editPersonKey = applicant.RentalApplicantKey;
    localStorage.setItem('AddAdditionalApplicantKey', editPersonKey.toString());
    this.analyticsService.track(
      'HRA Application',
      'Applicants',
      'Stop',
      'Editing application, sending to basic',
      '/application/basic',
      this.additionalAnalyticsDetails());
    this.router.navigate(['/application/basic']);

  }

  onContinueRemoveApplicant(){
    this.displayRemoveMsg = false;
    if (this.removedPersonRecord.RentalApplicationInvitationKey != null){
      this.applicationService.removeApplicantInvitationFromApplication(this.RentalApplicationKey, this.removedPersonRecord.RentalApplicationInvitationKey)
        .subscribe(res => this.onRemoveApplicantInvitation(res, this.removedPersonRecord.RentalApplicationInvitationKey), err => this.applicationService.handleError(err));
    }
    // viewmodels for invited applicants who haven't accepted their invite yet have a
    // RentalApplicantKey of 0 because no RentalApplicant record exists yet
    if (this.removedPersonRecord.RentalApplicantKey !== 0) {
      this.applicationService.removeApplicantFromApplication(this.RentalApplicationKey, this.removedPersonRecord.RentalApplicantKey)
        .subscribe(res => this.onRemoveApplicant(res, this.removedPersonRecord.RentalApplicantKey), err => this.applicationService.handleError(err));
    }
  }

  onCloseRemoveWarning() {
    this.displayRemoveMsg = false;
  }

  onRemoveApplicantInvitation(result: boolean, inviteKey: number) {
    if(result == true) {
      for (var i = this.applicants.length - 1; i >= 0; --i) {
        if (this.applicants[i].RentalApplicationInvitationKey == inviteKey) {
            this.applicants.splice(i,1);
            break;
        }
      }
    }
    else {
      this.errorMessage = "Error removing co-applicant";
    }
  }

  onRemoveApplicant(result: boolean, applicantKey: number) {
    if(result == true) {
      for (var i = this.applicants.length - 1; i >= 0; --i) {
        if (this.applicants[i].RentalApplicantKey == applicantKey) {
            this.applicants.splice(i,1);
            break;
        }
      }
    }
    else {
      this.errorMessage = "Error removing co-applicant";
    }
  }

  continue() {
    if (this.hasRentableItems) {
      this.analyticsService.track(
        'HRA Application',
        'Applicants',
        'Stop',
        'Has rentable items',
        '/application/rentables',
        this.additionalAnalyticsDetails());
      this.router.navigate(['/application/rentables'], { fragment: 'rentables' });
    } else if(this.PrimaryApplicant === this.RentalApplicantKey && !this.hasRentableItems) {
      this.analyticsService.track(
        'HRA Application',
        'Applicants',
        'Stop',
        'Primary applicant, has no rentable items',
        '/application/dashboard',
        this.additionalAnalyticsDetails());
      this.router.navigate(['/application/payment']);
    } else {
      this.analyticsService.track(
        'HRA Application',
        'Applicants',
        'Stop',
        'Not primary applicant, has no rentable items',
        '/application/dashboard',
        this.additionalAnalyticsDetails());
      this.router.navigate(['/application/dashboard', 'background']);
    }
  }
}
